import gql from 'graphql-tag'

export default gql`
  query getUser($id: Int!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
      updated_at
      roles {
        id
        slug
        name
        description
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/apollo/graphql/user/get.js